import microuniversoApi from "app/api/microuniversoApi"
import store from "app/redux/store/store"
import globalMU from "globalMU"
import { atualizarItemNoOrcamentoLegado } from "./atualizarItemNoOrcamentoLegado"

export type  DefinirValorIPIItemParams = {
    identificadorItem:number,
    valor: number,
    atualizarEstadoLegadoImediatamente?: boolean
    itemOrcamentoLegado?: any
}

export async function definirValorIPIItem(params: DefinirValorIPIItemParams) {
    try {
    
        globalMU.blockUI()

        const orcamentoAtualizado = await microuniversoApi.Orcamento.definirValorIPIIItem(
            store.getState().orcamento.IdentificadorOrcamento,
            params.identificadorItem, 
            params.valor)

        atualizarItemNoOrcamentoLegado(orcamentoAtualizado, params.identificadorItem, params.atualizarEstadoLegadoImediatamente)

    }finally {
        globalMU.unblockUI()
    }
}
